import { __extends } from "tslib";
import { AbstractionBase, AbstractMethodError } from '@awayjs/core';
import { ElementsEvent } from '../events/ElementsEvent';
import { ElementsUtils } from '../utils/ElementsUtils';
/**
 *
 * @class away.pool._Stage_ElementsBaseBase
 */
var _Stage_ElementsBase = /** @class */ (function (_super) {
    __extends(_Stage_ElementsBase, _super);
    function _Stage_ElementsBase() {
        var _this = _super.call(this) || this;
        _this.usages = 0;
        _this._vertices = {};
        _this._verticesUpdated = {};
        _this._indexMappings = [];
        _this._numIndices = 0;
        _this._onInvalidateIndicesDelegate = function (event) { return _this._onInvalidateIndices(event); };
        _this._onClearIndicesDelegate = function (event) { return _this._onClearIndices(event); };
        _this._onInvalidateVerticesDelegate = function (event) { return _this._onInvalidateVertices(event); };
        _this._onClearVerticesDelegate = function (event) { return _this._onClearVertices(event); };
        return _this;
    }
    Object.defineProperty(_Stage_ElementsBase.prototype, "elements", {
        get: function () {
            return this._useWeak ? this._asset.deref() : this._asset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_Stage_ElementsBase.prototype, "numIndices", {
        /**
         *
         */
        get: function () {
            return this._numIndices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_Stage_ElementsBase.prototype, "numVertices", {
        /**
         *
         */
        get: function () {
            return this._numVertices;
        },
        enumerable: false,
        configurable: true
    });
    _Stage_ElementsBase.prototype.init = function (elements, stage) {
        _super.prototype.init.call(this, elements, stage, true);
        elements.addEventListener(ElementsEvent.CLEAR_INDICES, this._onClearIndicesDelegate);
        elements.addEventListener(ElementsEvent.INVALIDATE_INDICES, this._onInvalidateIndicesDelegate);
        elements.addEventListener(ElementsEvent.CLEAR_VERTICES, this._onClearVerticesDelegate);
        elements.addEventListener(ElementsEvent.INVALIDATE_VERTICES, this._onInvalidateVerticesDelegate);
    };
    _Stage_ElementsBase.prototype.transformMatrix = function (renderRenderable, matrix) {
        return matrix;
    };
    /**
     *
     */
    _Stage_ElementsBase.prototype.getIndexMappings = function () {
        if (!this._indicesUpdated)
            this._updateIndices();
        return this._indexMappings;
    };
    /**
     *
     */
    _Stage_ElementsBase.prototype.getIndexBufferGL = function () {
        if (!this._indicesUpdated)
            this._updateIndices();
        return this._indices;
    };
    /**
     *
     */
    _Stage_ElementsBase.prototype.getVertexBufferGL = function (attributesView) {
        //first check if indices need updating which may affect vertices
        if (!this._indicesUpdated)
            this._updateIndices();
        var bufferId = attributesView.attributesBuffer.id;
        if (!this._verticesUpdated[bufferId])
            this._updateVertices(attributesView);
        return this._vertices[bufferId];
    };
    /**
     *
     */
    _Stage_ElementsBase.prototype.activateVertexBufferVO = function (index, attributesView, dimensions, offset) {
        if (dimensions === void 0) { dimensions = 0; }
        if (offset === void 0) { offset = 0; }
        this.getVertexBufferGL(attributesView)
            .activate(index, attributesView.size, dimensions || attributesView.dimensions, attributesView.offset + offset, attributesView.unsigned);
    };
    /**
     *
     */
    _Stage_ElementsBase.prototype.onClear = function () {
        var elements = this.elements;
        if (elements) {
            elements.removeEventListener(ElementsEvent.CLEAR_INDICES, this._onClearIndicesDelegate);
            elements.removeEventListener(ElementsEvent.INVALIDATE_INDICES, this._onInvalidateIndicesDelegate);
            elements.removeEventListener(ElementsEvent.CLEAR_VERTICES, this._onClearVerticesDelegate);
            elements.removeEventListener(ElementsEvent.INVALIDATE_VERTICES, this._onInvalidateVerticesDelegate);
        }
        if (this._overflow) {
            this._overflow.onClear();
            this._overflow = null;
        }
        this._indices = null;
        this._indicesUpdated = false;
        this._vertices = {};
        this._verticesUpdated = {};
        _super.prototype.onClear.call(this);
    };
    _Stage_ElementsBase.prototype._setRenderState = function (renderable, shader) {
        if (!this._verticesUpdated)
            this._updateIndices();
        //TODO replace overflow system with something sensible
        //this._render(renderable, camera, viewProjection);
        //
        // if (this._overflow)
        // 	this._overflow._iRender(renderable, camera, viewProjection);
    };
    _Stage_ElementsBase.prototype.draw = function (renderable, shader, count, offset) {
        throw new AbstractMethodError();
    };
    /**
     * //TODO
     *
     * @private
     */
    _Stage_ElementsBase.prototype._updateIndices = function (indexOffset) {
        if (indexOffset === void 0) { indexOffset = 0; }
        var elements = this.elements;
        var indices = elements.indices;
        if (indices) {
            var sub = ElementsUtils.getSubIndices(indices, elements.numVertices, this._indexMappings, indexOffset);
            this._indices = this._pool.abstractions.getAbstraction(sub);
            this._numIndices = this._indices.attributesBuffer.count * indices.dimensions;
        }
        else {
            this._indices = null;
            this._numIndices = 0;
            this._indexMappings.length = 0;
        }
        indexOffset += this._numIndices;
        //check if there is more to split
        if (indices && indexOffset < indices.count * elements.indices.dimensions) {
            if (!this._overflow)
                this._overflow = this._pGetOverflowElements();
            this._overflow._updateIndices(indexOffset);
        }
        else if (this._overflow) {
            this._overflow.onClear();
            this._overflow = null;
        }
        this._indicesUpdated = true;
        //invalidate vertices if index mappings exist
        if (this._indexMappings.length)
            for (var key in this._verticesUpdated)
                this._verticesUpdated[key] = false;
    };
    /**
     * //TODO
     *
     * @param attributesView
     * @private
     */
    _Stage_ElementsBase.prototype._updateVertices = function (attributesView) {
        this._numVertices = this.elements.numVertices;
        var bufferId = attributesView.attributesBuffer.id;
        var sub = ElementsUtils.getSubVertices(attributesView.attributesBuffer, this._indexMappings);
        this._vertices[bufferId] = this._pool.abstractions.getAbstraction(sub);
        this._verticesUpdated[bufferId] = true;
    };
    /**
     * //TODO
     *
     * @param event
     * @private
     */
    _Stage_ElementsBase.prototype._onInvalidateIndices = function (event) {
        if (!event.attributesView)
            return;
        this._indicesUpdated = false;
    };
    /**
     * //TODO
     *
     * @param event
     * @private
     */
    _Stage_ElementsBase.prototype._onClearIndices = function (event) {
        if (!event.attributesView)
            return;
        this._indices.onClear();
        this._indices = null;
    };
    /**
     * //TODO
     *
     * @param event
     * @private
     */
    _Stage_ElementsBase.prototype._onInvalidateVertices = function (event) {
        if (!event.attributesView)
            return;
        var bufferId = event.attributesView.attributesBuffer.id;
        this._verticesUpdated[bufferId] = false;
    };
    /**
     * //TODO
     *
     * @param event
     * @private
     */
    _Stage_ElementsBase.prototype._onClearVertices = function (event) {
        if (!event.attributesView)
            return;
        var bufferId = event.attributesView.attributesBuffer.id;
        if (this._vertices[bufferId]) {
            this._vertices[bufferId].onClear();
            delete this._vertices[bufferId];
            delete this._verticesUpdated[bufferId];
        }
    };
    /**
     * //TODO
     *
     * @param pool
     * @param renderable
     * @param level
     * @param indexOffset
     * @returns {away.pool.GL_ShapeRenderable}
     * @protected
     */
    _Stage_ElementsBase.prototype._pGetOverflowElements = function () {
        throw new AbstractMethodError();
    };
    return _Stage_ElementsBase;
}(AbstractionBase));
export { _Stage_ElementsBase };
